import type { RoleListApiResponse } from '@navio/nsdk';
import { keepPreviousData } from '@tanstack/react-query';
import { URLKeys } from 'noddi-async';
import type { FilterOption, FilterOptionSource } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { useState } from 'react';
import { toFilterOptionSource, useFilterOptionsGet } from '../../hooks/filters/useFilterOptionsGet';

/** IAM roles as filter options, searchable, without the impersonated user's scope. For `unit.multiSelect`. */
export const useImpersonationRoleOptions = (): FilterOptionSource<string> => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getPaginatedIamRolesIgnoringImpersonation,
    input: { pageSize: 100, search: debouncedSearch || undefined },
    queryConfig: { placeholderData: keepPreviousData, select: toRoleOptions }
  });

  return toFilterOptionSource(query, 'string', { search, onSearch: setSearch });
};

const toRoleOptions = ({ results }: RoleListApiResponse): FilterOption<string>[] =>
  results.map((role) => ({ value: role.roleId, label: role.name }));
